import { z } from 'zod';

const decimalStringSchema = z.string().regex(/^-?\d+(?:\.\d+)?$/);
const instantSchema = z.string().datetime({ offset: true });

export const manualOpeningBalanceSchema = z
  .object({
    reported_balance: decimalStringSchema,
    as_of: instantSchema,
  })
  .strict();

export const manualLaterBalanceSchema = z
  .object({
    operation_id: z.string(),
    expected_version: z.number().int().nonnegative(),
    reported_balance: decimalStringSchema,
    currency: z.string(),
    as_of: instantSchema,
  })
  .strict();

export const manualBalanceHistoryRowSchema = z
  .object({
    balance_id: z.string(),
    account_id: z.string(),
    balance: decimalStringSchema,
    currency: z.string(),
    as_of: instantSchema,
    source: z.string(),
  })
  .strict();

const manualBalanceHistoryMetaSchema = z
  .object({
    next_cursor: z.string().nullable(),
  })
  .strict();

export const manualBalanceHistoryResponseSchema = z
  .object({
    data: z.array(manualBalanceHistoryRowSchema),
    meta: manualBalanceHistoryMetaSchema,
  })
  .strict();

export type ManualOpeningBalance = z.infer<typeof manualOpeningBalanceSchema>;
export type ManualLaterBalance = z.infer<typeof manualLaterBalanceSchema>;
export type ManualBalanceHistoryRow = z.infer<typeof manualBalanceHistoryRowSchema>;
export type ManualBalanceHistoryResponse = z.infer<typeof manualBalanceHistoryResponseSchema>;
export type ManualBalanceHistoryResult = { kind: 'unavailable' };

export function parseManualBalanceHistoryResponse(payload: unknown): ManualBalanceHistoryResponse {
  return manualBalanceHistoryResponseSchema.parse(payload);
}

export function useManualBalanceHistory(_accountId: string | undefined): ManualBalanceHistoryResult {
  return { kind: 'unavailable' };
}
